export default __webpack_public_path__ + "static/media/xlsx.98937d23.png";